'use strict';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var angular = require('angular');
var _ = require('lodash');
var JQXGridCustomSortService = function JQXGridCustomSortService($filter, SortCriteria, SortColumn, LatestSortService, gridCustomSortFunctionsService) {
  var defaultSortCriteriaIndex = {};
  function sortGridColumns(data, sortCriteria) {
    var filterPredicate = getFilterPredicate(sortCriteria);
    var orderBy = $filter('orderBy');
    var newEmptyRows = _.filter(data, isNewEmptyGridRow);
    var filledRows = _.filter(data, isNotNewEmptyGridRow);
    return filterPredicate.length < 1 ? data : newEmptyRows.concat(orderBy(filledRows, filterPredicate));
  }
  function isNewEmptyGridRow(el) {
    if (el.isNewlyAdded || _.isEmpty(el) || Object.keys(el).length === 1 && el._old) {
      return true;
    } else if (el._old && _.intersection(Object.keys(el), Object.keys(el._old)).length === 0) {
      for (var prop in el._old) {
        if (el._old[prop] !== undefined) {
          return false;
        }
      }
      return true;
    }
    return false;
  }
  function isNotNewEmptyGridRow(el) {
    return !isNewEmptyGridRow(el);
  }
  function getFilterPredicate(sortCriteria) {
    return _.transform(sortCriteria.getActiveSortColumns(), function (result, sortColumn) {
      var sortModifier = sortColumn.isSortDescending() ? '-' : '+';
      var field = sortColumn.field;
      var customSortFunction = gridCustomSortFunctionsService.getCustomSort(field, sortModifier);
      if (customSortFunction !== null) {
        return result.push(customSortFunction);
      }
      result.push('!' + field + '&&' + field + '!==0');
      return result.push(sortModifier + field);
    });
  }
  function parseSortCriteria(columns, directions) {
    var sortDirections = [];
    if (typeof directions === 'boolean') {
      sortDirections.push(directions);
    } else if ((0, _typeof2["default"])(directions) === 'object' && directions !== null) {
      sortDirections.push(directions.ascending ? true : directions.descending ? false : '');
    } else if (typeof directions === 'string') {
      sortDirections = sortDirections.concat(directions.split(','));
    }
    var sortColumns = _.transform(columns.split(','), function (result, column, index) {
      var direction = sortDirections[index];
      return result.push(new SortColumn(column, direction));
    });
    return new SortCriteria(sortColumns);
  }
  function getSortCriteria(columns, directions) {
    if (columns instanceof SortCriteria) {
      if (directions === null) {
        columns.reset();
      }
      return columns;
    } else {
      return parseSortCriteria(columns, directions);
    }
  }
  function sortBy(data, sortCriteria) {
    return sortGridColumns(data, sortCriteria);
  }
  function storeLatestSortCriteria(gridId, sortCriteria) {
    var sortedColumns = sortCriteria.clone().getActiveSortColumns();
    var latestSortCriteria = new SortCriteria(sortedColumns);
    if (sortCriteria.isCustomSort() && sortedColumns.length > 0) {
      latestSortCriteria.setIsCustomSort(true);
    }
    LatestSortService.addLatestSortCriteria(gridId, latestSortCriteria);
  }
  function sortGrid(adapter, gridId, columns, directions) {
    var sortCriteria = getSortCriteria(columns, directions);
    if (sortCriteria.getActiveSortColumns().length < 1) {
      sortCriteria = defaultSortCriteriaIndex[gridId];
    }
    if (adapter.originaldata && adapter.originaldata instanceof Array) {
      adapter.localdata = sortBy(adapter.originaldata.slice(), sortCriteria);
      angular.element('#' + gridId).each(function (ix, grid) {
        var gridElement = angular.element(grid);
        gridElement.trigger({
          type: 'beforeUpdateBoundData'
        });
        gridElement.jqxGrid('updatebounddata', 'sort');
      });
    }
    storeLatestSortCriteria(gridId, sortCriteria);
  }
  function getCustomSorter(adapter, gridId) {
    return function (columns, directions) {
      sortGrid(adapter, gridId, columns, directions);
    };
  }
  function setDefaultSortCriteria(gridId, sortCriteria) {
    defaultSortCriteriaIndex[gridId] = sortCriteria.clone();
  }
  return {
    getCustomSorter: getCustomSorter,
    sortBy: sortBy,
    getSortCriteria: getSortCriteria,
    setDefaultSortCriteria: setDefaultSortCriteria
  };
};
JQXGridCustomSortService.$inject = ['$filter', 'SortCriteriaFactory', 'SortColumnFactory', 'JQXGridLatestSortService', 'GridCustomSortFunctionsService'];
module.exports = JQXGridCustomSortService;